export default __webpack_public_path__ + "static/media/feeds_error_message.cc958eb9.svg";